// extracted by mini-css-extract-plugin
export var cartIcon = "_p3-0";
export var cartIconContainer = "_p3-1";